<template>
    <div class="classify-item-wrapper" :class="{ actived: actived === data.uId }" @click="itemClick">
        <div class="left-content">
            <div class="classify-name">{{ data.classify }}</div>
            <div class="lang-name">{{ langLabel[data.lang] }}</div>
        </div>
        <div class="right-content">
            <div class="create-time">{{ data.updateTime }}</div>
            <div class="classify-status">
                <span class="show-item-status" :class="{ 'status-online': 'online' == data.status }">
                    {{ statusLabel[data.status] }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { businessLangs } from "@/components/langSelect/languages.js";
import i18n from "@/i18n";

const getLangs = () => {
    let obj = {};
    businessLangs().forEach(lang => {
        obj[lang.lang] = i18n.t(lang.i18nKey);
    });
    return obj;
};

export default {
    name: "ClassifyItem",
    props: ["data", "actived"],
    computed: {
        statusLabel() {
            return {
                online: this.$t("zhiji.knowlege.alreadyOn"),
                offline: this.$t("zhiji.knowlege.alreadyOff"),
                draft: this.$t("zhiji.knowlege.draft")
            };
        },
        langLabel() {
            return getLangs();
        }
    },
    methods: {
        itemClick() {
            this.$emit("itemClick", this.data);
        }
    }
};
</script>

<style lang="scss" scoped>
.classify-item-wrapper {
    cursor: pointer;
    display: flex;
    padding: 13px 16px;
    border-width: 0 0 1px 0;
    border-color: #d8e4f0;
    border-style: solid;
    &:hover {
        background: #d9ebf6;
    }
    .left-content {
        padding-right: 16px;
        box-sizing: border-box;
        flex: 1;
        overflow: hidden;
        .classify-name {
            font-size: 14px;
            margin-bottom: 3px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .lang-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .right-content {
        width: 130px;
        text-align: right;
        .create-time {
            margin-bottom: 4px;
        }
    }
    .classify-status {
        .show-item-status {
            display: inline-block;
            min-width: 46px;
            height: 20px;
            background: #eaecee;
            color: #9b9ba3;
            font-size: 12px;
            border-radius: 4px;
            line-height: 20px;
            text-align: center;
            border: 1px solid #d8e4f0;
        }
        .status-online {
            color: #00c972;
            background: #f2f7fb;
        }
    }
}
.actived {
    background: #d9ebf6;
}
</style>
